import { toast as sonnerToast } from "sonner";
import { ReactNode } from "react";

export const toast = {
  success: (message: string | ReactNode, options?: { id?: string; duration?: number }) => {
    if (options?.id) {
      sonnerToast.dismiss(options.id);
    }
    sonnerToast.success(message, { duration: options?.duration });
  },

  error: (message: string | ReactNode, options?: { id?: string }) => {
    if (options?.id) {
      sonnerToast.dismiss(options.id);
    }
    sonnerToast.error(message);
  },

  info: (message: string | ReactNode, options?: { id?: string }) => {
    if (options?.id) {
      sonnerToast.dismiss(options.id);
    }
    sonnerToast.info(message);
  },

  loading: (message: string) => {
    const id = Math.random().toString(36).substring(7);
    sonnerToast.loading(message, {
      id,
      duration: Infinity
    });
    return id;
  }
};